import FormLine from 'components/Forms/Lib/FormLine/FormLine';
import FormLineError from 'components/Forms/Lib/FormLineError/FormLineError';
import TextInput from 'components/Forms/TextInput/TextInput';
import { EmailAlreadyRegistered } from 'components/Pages/Order/ContactInformation/ContactInformationEmail/EmailAlreadyRegistered';
import { RegistrationFormType, useRegistrationFormMeta } from 'components/Pages/Registration/formMeta';
import { useEmailAlreadyRegistered } from 'hooks/user/useEmailAlreadyRegistered';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

export const Account: FC = () => {
    const formProviderMethods = useFormContext<RegistrationFormType>();
    const formMeta = useRegistrationFormMeta(formProviderMethods);

    const [emailValue] = useWatch({
        name: [formMeta.fields.email.name],
        control: formProviderMethods.control,
    });
    const isEmailValid = !formProviderMethods.formState.errors[formMeta.fields.email.name];
    const { isEmailAlreadyRegistered } = useEmailAlreadyRegistered({
        email: isEmailValid && emailValue ? emailValue : null,
    });

    return (
        <>
            <FormLine bottomGap className="w-full flex-none">
                <Controller
                    name={formMeta.fields.email.name}
                    render={({ fieldState: { isTouched, invalid, error }, field }) => (
                        <>
                            <TextInput
                                required
                                fieldRef={field}
                                hasError={invalid}
                                id={formMeta.getFieldId(formMeta.fields.email.name)}
                                isTouched={isTouched}
                                label={formMeta.fields.email.label}
                                name={formMeta.fields.email.name}
                                type="text"
                            />
                            <FormLineError
                                data-testid={formMeta.formName + '-' + formMeta.fields.email.name + '-error'}
                                error={error}
                                inputType="text-input"
                            />
                            {isEmailAlreadyRegistered && <EmailAlreadyRegistered />}
                        </>
                    )}
                />
            </FormLine>
            <FormLine bottomGap className="w-full flex-none">
                <Controller
                    name={formMeta.fields.passwordFirst.name}
                    render={({ fieldState: { isTouched, invalid, error }, field }) => (
                        <>
                            <TextInput
                                required
                                fieldRef={field}
                                hasError={invalid}
                                id={formMeta.getFieldId(formMeta.fields.passwordFirst.name)}
                                isTouched={isTouched}
                                label={formMeta.fields.passwordFirst.label}
                                name={formMeta.fields.passwordFirst.name}
                                type="password"
                            />
                            <FormLineError
                                data-testid={formMeta.formName + '-' + formMeta.fields.passwordFirst.name + '-error'}
                                error={error}
                                inputType="text-input-password"
                            />
                        </>
                    )}
                />
            </FormLine>
            <FormLine bottomGap className="w-full flex-none">
                <Controller
                    name={formMeta.fields.passwordSecond.name}
                    render={({ fieldState: { isTouched, invalid, error }, field }) => (
                        <>
                            <TextInput
                                required
                                fieldRef={field}
                                hasError={invalid}
                                id={formMeta.getFieldId(formMeta.fields.passwordSecond.name)}
                                isTouched={isTouched}
                                label={formMeta.fields.passwordSecond.label}
                                name={formMeta.fields.passwordSecond.name}
                                type="password"
                            />
                            <FormLineError
                                data-testid={formMeta.formName + '-' + formMeta.fields.passwordSecond.name + '-error'}
                                error={error}
                                inputType="text-input-password"
                            />
                        </>
                    )}
                />
            </FormLine>
        </>
    );
};
